import { createFileRoute } from "@tanstack/react-router";
import { PhonesPage } from "@features/assets/components/PhonesPage";

export const Route = createFileRoute("/_layout/assets/phones")({
	validateSearch: (search: Record<string, unknown>): { phone?: number } => ({
		phone:
			Number.isInteger(Number(search.phone)) && Number(search.phone) > 0
				? Number(search.phone)
				: undefined,
	}),
	component: PhonesRoute,
	staticData: { crumb: { label: "Phones" } },
});
function PhonesRoute() {
	const { phone } = Route.useSearch();
	return <PhonesPage initialPhoneId={phone} />;
}
